import { Collapse, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import React from 'react';
import {KeyboardArrowDown, KeyboardArrowUp} from '@mui/icons-material';
import { Box } from '@mui/system';
import Details from '../Details/Details';
import { ICollapsibleTable, IResponseData, ITitle } from './type';
import Pagination from '../Pagination/Pagination';


function createData(row: IResponseData, headerTitles: ITitle[], subHeaderTitles: ITitle[]) {  
  const obj = {};
  const childrenObj = {};
  headerTitles.map((header: ITitle) => {
    Object.assign(obj, {
      [header.refValue]: row[header.refValue]
    });   
  });
  subHeaderTitles.map((subHeader: ITitle) => {
    Object.assign(childrenObj, {
      [subHeader.refValue]: row[subHeader.refValue]
    });
  });  
  Object.assign(obj, { children: childrenObj });
  
  return obj;
}

function createDetailsData(row: any, subHeaderTitles: ITitle[]) {  
  return subHeaderTitles.map((subHeader: ITitle) => {
    return {
      name: subHeader.title,
      value: row.children[subHeader.refValue]
        ? String(row.children[subHeader.refValue])
        : '-'
    };
  });
}

function Row(props: {
  row: any,
  headerTitles: ITitle[],
  subHeaderTitles: any, // ITitle[] | { key: string , value: ITitle[] }[]
  extraInfoHeader: string,
  subHeaderBasedOn: string
}) {
  const { row, headerTitles, subHeaderTitles, extraInfoHeader, subHeaderBasedOn } = props;
  const [open, setOpen] = React.useState(false);
  let _header = subHeaderTitles;
  if ('key' in subHeaderTitles[0]) {
    _header =
      subHeaderTitles
        .find((x: { key: string , value: ITitle[] }) => x.key === row[subHeaderBasedOn]).value;    
  }

  return (
    <>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
          <IconButton
            aria-label='expand row'
            size='small'
            onClick={() => setOpen(!open)}
          >
            {open
              ? <KeyboardArrowUp />
              : <KeyboardArrowDown />}
          </IconButton>
        </TableCell>
        {headerTitles.map((header: ITitle) => <TableCell key={JSON.stringify(header)} component='th'
          scope='row'>
          {row[header.refValue]}
        </TableCell>)
        }
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout='auto'
            unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography fontWeight='bold' gutterBottom>
                {extraInfoHeader}
              </Typography>
              <Details removeLines rows={createDetailsData(row, _header as ITitle[])}/>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

const CollapsibleTable = (props: ICollapsibleTable) => {
  const { 
    rows, 
    headerTitles,
    subHeaderTitles,
    extraInfoHeader='Επιπλέον Πληροφορίες',
    subHeaderBasedOn='',
    pagination = {
      handleOnPageChange: () => undefined,
      itemsPerPage: 0,
      selectedPage: 0,
      totalResults: 0,
      enablePagination: false
    }
  } = props;

  const { handleOnPageChange,
    itemsPerPage,
    selectedPage,
    totalResults: totalPages,
    enablePagination
  } = pagination;

  const _rows = rows?.map((row: IResponseData) => {
    
    if ('title' in subHeaderTitles[0]) return createData(row, headerTitles, subHeaderTitles as ITitle[]);
    
    const _x: ITitle[] = 
      subHeaderTitles
        .find((x: { key: string , value: ITitle[] }) => x.key === row[subHeaderBasedOn]).value;

    return createData(row, headerTitles, _x as ITitle[]);

  });

  return (
    <>
      <TableContainer >
        <Table aria-label='collapsible table'>
          <TableHead>
            <TableRow>
              <TableCell />
              {
                headerTitles.map((title: ITitle) => {
                  return (
                    <TableCell key={title.refValue} sx={{fontWeight: 'bold'}}>{title.title}</TableCell>
                  );
                })
              }
            </TableRow>
          </TableHead>
          <TableBody>
            {_rows.map((row: ReturnType<typeof createData>) => (
              <Row key={JSON.stringify(row)} row={row}
                headerTitles={headerTitles} subHeaderTitles={subHeaderTitles}
                extraInfoHeader={extraInfoHeader}
                subHeaderBasedOn={subHeaderBasedOn}/>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box mt={2}>
        {enablePagination
          ? <Pagination
            itemsPerPage={itemsPerPage}
            totalItems={totalPages}
            currentPage={selectedPage}
            onPageChange={handleOnPageChange} 
          />
          : null
        }
      </Box>
    </>
  );
};

export default CollapsibleTable;